import ajax from "../utils/request";

const ModuleApi = {
  // 获取列表
  getModuleList(params) {
    return ajax({
      url: "/module/conf/list",
      type: "post",
      params: params,
    });
  },
  subBatchModuleList(params) {
    return ajax({
      url: "/vid/batch/module",
      type: "post",
      params: params,
    });
  },
  // 添加
  addModule(params) {
    return ajax({
      url: "/module/conf/add",
      type: "post",
      params: params,
    });
  },
  // 编辑
  editModule(params) {
    return ajax({
      url: "/module/conf/edit",
      type: "post",
      params: params,
    });
  },
  // 删除
  deleteModule(params) {
    return ajax({
      url: "/module/conf/delete",
      type: "post",
      params: params,
    });
  },
};
export default ModuleApi;
